import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import Modal from '../../UI/Modal/BasicModal';
import { Classes, StyledMenu } from './NotificationsMenu.styles';
import { Box, CircularProgress, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import CircleIcon from '@mui/icons-material/Circle';
import { ListItemIcon, ListItemText } from '@mui/material/';
import { grey, red } from '@mui/material/colors';
import Logo from '../../UI/Logo';
import { prettyDate } from '../../../utils/dates';
import { Waypoint } from 'react-waypoint';
import { formatString } from '../../../utils/numbers';

export default function NotificationMenu({
	anchorEl,
	handleClose,
	markAsRead,
	notifications,
	fetchNotifications,
	hasMore
}) {
	const [openModal, setOpenModal] = useState(false);
	const [notification, setNotification] = useState({});
	const location = useLocation();

	useEffect(() => {
		if (anchorEl) {
			handleClose();
		}
	}, [location]);

	const handleClick = async (notif) => {
		setOpenModal(true);
		setNotification(notif);
		await markAsRead(notif.ID);
	};

	const removeHTMLTags = (text) => {
		return text.replace(/(<([^>]+)>)/gi, '');
	};

	return (
		<StyledMenu
			anchorEl={anchorEl}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			transformOrigin={{ vertical: 'top', horizontal: 'center' }}
			open={Boolean(anchorEl)}
			MenuListProps={{ className: Classes.menuList }}
			onClose={handleClose}
			keepMounted
		>
			<Box
				display="flex"
				alignItems="left"
				justifyContent="left"
				padding="5px 25px"
				className={Classes.header}
			>
				<Typography variant="subtitle1" color="white" fontWeight="bold">
					Notificări
				</Typography>
			</Box>
			{notifications && notifications.length > 0
				? notifications.map((notification) => (
						<MenuItem
							onClick={() => handleClick(notification)}
							key={notification.ID}
							sx={{
								backgroundColor: notification.Status !== 3 ? 'primary.hover' : null,
								paddingLeft: 0
							}}
						>
							<Box display="flex" alignItems="center" justifyContent="center">
								{notification.Status !== 3 ? (
									<CircleIcon sx={{ color: red[600], height: '5px' }} />
								) : null}
								<ListItemIcon
									sx={{
										marginLeft: notification.Status === 3 ? '1.5em' : null,
										marginRight: '1em'
									}}
								>
									<Logo height="30px" />
								</ListItemIcon>
							</Box>
							<ListItemText
								primary={
									<>
										<Typography
											sx={{
												display: 'inline-block',
												whiteSpace: 'pre-line',
												fontWeight: '500'
											}}
										>
											{notification.Title}
										</Typography>
										<Typography variant="inherit" className={Classes.subtitle}>
											{removeHTMLTags(notification.Message)}
										</Typography>
									</>
								}
								secondary={
									<Typography variant="subtitle2" sx={{ color: grey[500], fontWeight: '400' }}>
										{prettyDate(notification.CreatedAt)}
									</Typography>
								}
							/>
						</MenuItem>
				  ))
				: null}
			{hasMore ? (
				<Waypoint onEnter={fetchNotifications} topOffset="20px">
					<Box display="flex" justifyContent="center">
						<CircularProgress />
					</Box>
				</Waypoint>
			) : null}
			{openModal ? (
				<Modal
					openModal={openModal}
					height="100%"
					maxWidth="sm"
					setOpenModal={setOpenModal}
					title={notification.Title}
				>
					<>{formatString(notification.Message)}</>
				</Modal>
			) : null}
		</StyledMenu>
	);
}
